// Dependencies
import { h, Component, Fragment } from 'preact';
import {connect} from 'react-redux'

// Components
import WidgetComponent from 'components/WidgetComponent'
import { I18n, Button } from 'components/elements'
import {WaitingRoom} from 'components/groups'

// Actions
import {SessionActions,PageActions} from 'actions';

// Styles
import style from './style'

// Animation Component
import LottieAnimation from 'components/elements/LottieAnimation';
import animationSuccess from "../../../assets/animations/success.json";


// Component
@connect((state)=> state)
export default class Receipt extends WidgetComponent {

    // Constructor
	constructor(){
        super()
        this.handleBack = this.handleBack.bind(this)
        this.handleLogout= this.handleLogout.bind(this)
    }
    
    // Methods
    handleLogout(e){
        SessionActions.logout()
    }

    handleBack(e){
        PageActions.reset()
    }

    parseAndSentence(sentence){
        
        if(sentence.length == 1){
            return (
                <Fragment>
                    <I18n>and</I18n> {sentence}
                </Fragment>
            )
        }else{
            return (
                <Fragment>
                    {sentence.slice(0, sentence.length - 1).join(', ')}, <I18n>and</I18n> {sentence.slice(sentence.length - 1, sentence.length)}
                </Fragment>
            )
        }
    }
    
    // Getters
    get account() {
        return (this.props.session || {}).account || {};
    }

    get fullNameAccount(){ 
        const firstName = this.account.firstName || ''
        const lastName = this.account.lastName || ''
        return `${firstName} ${lastName}`
    }

    get administrator(){
        return this.props.administrators[this.props.selectedTimeSlot.administratorID] || {}
    }
    
    get patients(){
        return Object.values(this.props.patients || {}).filter((patient)=> Object.keys(this.props.selectedPatients).includes(patient.id))
    }

    get patientNames(){
        let names = []
        this.patients.forEach((patient)=>{
            if(!names.length){
                names.push(`${patient.firstName}`)
            } else {
                names.unshift(patient.firstName)
            }
        })
        return names
    }

    get appointment(){
        return this.props.timeSlots[this.props.selectedTimeSlot.administratorID][this.props.selectedTimeSlot.id] || {}
    }

    // Render Method
	render() {
		return (
            <div className={style.receipt}>
                <div class={style.header} style={this.props.waitingRoom ?{paddingTop:0}:{}}>
                    <div className={style.animation}>
                        <LottieAnimation animationData={animationSuccess} loop={false} />
                    </div>
                    <div class={style.title}>
                        <I18n>yourAppointmentIsReady</I18n>
                    </div>
                    <div class={style.subtitle}>
                        <span><I18n>ThankYouForSchedulingWithUs</I18n></span>
                        <span><I18n>seeYouSoon</I18n>{`, ${this.fullNameAccount}!`}</span>
                    </div>
                </div>
                {this.props.waitingRoom &&
                    <div>
                        <WaitingRoom />
                    </div>
                }
                <div class={style.footer}>
                    <div className={style.returnBtn}>
                        <strong>Need another appointment?</strong>
                        <div onClick={this.handleBack} class={style.link}><I18n>backToStart</I18n></div>
                    </div>
                    <Button onClick={this.handleLogout} class={style.link}><I18n>logOut</I18n></Button>
                </div>
            </div>
		)
	}
}


// WEBPACK FOOTER //
// ./components/templates/Receipt/index.js